import { registerAuditLabels, type StatusMap } from "@vixio/ui";

export const SEVERITY: StatusMap = { critico: { label: "crítico", tone: "crit" }, atencao: { label: "atenção", tone: "warn" }, info: { label: "informativo", tone: "info" } };
export const STATUS: StatusMap = { aberto: { label: "aberto", tone: "crit" }, reconhecido: { label: "reconhecido", tone: "warn" }, resolvido: { label: "resolvido", tone: "ok" } };
export const CATEGORIES: Record<string, string> = {
  rota: "Rota (§3.8)", contratacao: "Contratação (§3.6)", capacidade: "Capacidade", pausa: "Critério de pausa (§15.1)", caixa: "Caixa (§20)", operacao: "Operação (§20)", ia: "IA",
};
export const KINDS: Record<string, string> = { kpi_threshold: "Indicador no período", kpi_window: "Indicadores numa janela", kpi_streak: "Sequência de períodos", event: "Evento" };
export const RULE_STATE: StatusMap = {
  ok: { label: "ok", tone: "ok" }, disparou: { label: "disparou", tone: "crit" }, sem_dado: { label: "sem dado", tone: "neutral" },
  aguardando: { label: "aguardando prazo", tone: "info" }, evento: { label: "por evento", tone: "info" }, erro: { label: "erro", tone: "crit" },
};

export interface AlertView {
  id: string;
  org_id: string;
  rule_key: string;
  category: string | null;
  source_ref: string | null;
  severity: "info" | "atencao" | "critico";
  title: string;
  message: string;
  detail: string | null;
  action: string | null;
  status: "aberto" | "reconhecido" | "resolvido";
  raised_at: string;
  acknowledged_at: string | null;
  resolved_at: string | null;
  resolution_note: string | null;
  notified: number;
}

export interface Rule {
  id: string;
  org_id: string;
  key: string;
  label: string;
  description: string | null;
  category: string;
  kind: string;
  params: Record<string, unknown>;
  severity: string;
  message: string;
  action: string | null;
  source_ref: string | null;
  active: boolean;
  last_checked_at: string | null;
  last_state: { status?: string; detail?: string } | null;
}

export interface Settings {
  org_id: string;
  email: string | null;
  whatsapp_person_id: string | null;
  notify_channel: "email" | "whatsapp" | "ambos" | "nenhum";
  min_severity: "info" | "atencao" | "critico";
  plan_start: string;
}

export interface LogEntry { id: number; alert_id: string; kind: string; note: string | null; created_at: string }

type U = string;
declare module "@vixio/data" {
  interface RpcRegistry {
    "alerts.run_checks": { args: { p_date?: string | null; p_org?: U | null }; returns: number };
    "alerts.acknowledge": { args: { p_alert: U; p_note?: string | null }; returns: null };
    "alerts.resolve_alert": { args: { p_alert: U; p_note: string }; returns: null };
    "alerts.set_settings": { args: { p_org: U; p_email: string | null; p_whatsapp_person?: U | null; p_notify_channel?: string; p_min_severity?: string; p_plan_start?: string | null }; returns: null };
    "alerts.upsert_rule": {
      args: { p_org: U; p_key: string; p_label: string; p_kind: string; p_params: Record<string, unknown>; p_message: string; p_severity?: string; p_action?: string | null; p_category?: string; p_description?: string | null; p_source_ref?: string | null; p_active?: boolean };
      returns: U;
    };
    "alerts.install_defaults": { args: { p_org: U; p_email?: string | null; p_plan_start?: string | null }; returns: null };
  }
}

registerAuditLabels({
  "alerts.resolved": "Sinal resolvido",
  "alerts.settings_set": "Aviso de sinais configurado",
  "alerts.rule_upserted": "Regra de sinal salva",
  "alerts.defaults_installed": "Sinais do PM3 instalados",
});
